if (!customElements.get('responsive-video')) {
  customElements.define(
    'responsive-video',
    class ResponsiveVideo extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setVideoState();
        this.setEventListeners();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          video: this.querySelector('[js-responsive-video="video"]'),
          videoDesktop: this.querySelector('[js-responsive-video="videoDesktop"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        window.addEventListener('resize', debounce(this.setVideoState).bind(this));
      }

      /**
       * Sets the active video state based on breakpoints.
       */
      setVideoState() {
        const { large } = getBreakpoints();
        const isDesktop = window.matchMedia(`(min-width: ${large}px)`).matches;

        if (isDesktop && this.nodeSelectors.videoDesktop) {
          this.setActiveVideoElement(this.nodeSelectors.videoDesktop);
          return;
        }

        this.setActiveVideoElement(this.nodeSelectors.video);
      }

      /**
       * Shows the provided video element and hides others.
       * @param {HTMLVideoElement} videoElement - The video element to show.
       */
      setActiveVideoElement(videoElement) {
        const videos = [this.nodeSelectors.video, this.nodeSelectors.videoDesktop];

        this.loadLazyVideo(videoElement);

        videos.forEach((video) => {
          if (!video || videoElement === video) {
            return;
          }
        });
      }

      /**
       * Loads a lazy video element.
       * @param {HTMLVideoElement} videoElement - The video element to load.
       */
      loadLazyVideo(videoElement) {
        if (!videoElement || videoElement.querySelector('source').hasAttribute('src')) {
          return;
        }

        [...videoElement.querySelectorAll('source')].forEach((source) => {
          if (source.dataset.src) {
            source.src = source.dataset.src;
          }
        });

        videoElement.load();
      }
    }
  );
}
